import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { config } from 'config';

type Props = {
  canonical?: string;
};

export const MetaCanonical = ({ canonical }: Props) => {
  const { pathname } = useLocation();
  const path = canonical || pathname;
  const url = `${config.ENV.ORIGIN_URL}${path}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta content={url} property="og:url" />
    </Helmet>
  );
};
